import React, { useState, useEffect } from 'react';
import { SpinLoading } from 'antd-mobile-v5'
import { withRouter } from 'react-router';
const AeAutoScale = (props) => {

    useEffect(() => {
        window.document.title = '自测量表'
        let scaleCode = new URLSearchParams(props.location.search).get('scaleCode')
        let code = new URLSearchParams(props.location.search).get('code')
        // console.log('scaleCode', scaleCode);
        // console.log('code', code);
        const formData = {
            crfCode: scaleCode
        }
        sessionStorage.setItem('AeScaleFormData', JSON.stringify(formData));
        sessionStorage.setItem('enterType', 'share');
        props.history.push(`/alk/scale?code=${code}`);
    }, [])

    return (
        <div>
            <SpinLoading />
        </div>
    )
}

export default withRouter(AeAutoScale) 